
const AboutMe = () => {

    return (
        <div id="AboutMe" className="AboutMe-Page">
            <h1 className="aboutme-Title">About Me</h1>
            <div className="AboutMe-information">
                <div className="AboutMe-information-Text">
                    <h1>Hi! 👋 <br/><br/>
                    I'm Khaled Jafar, I'm a Web Frontend Developer 
                    located in Amman, Jordan. I have a passion for creating 
                    beautiful and functional web applications.
                    <br/><br/>
                    Well organized person, detail-oriented and a team player, 
                    I am always looking for challenging opportunities to learn and grow.
                    <br/><br/>
                    Aside from work, I love sports, traveling and spending time with my Family.
                    </h1>
                </div>
                <div className="AboutMe-information-Avatar-container">
                    <img src="./images/Avatar.png" alt="PersonalPicture" className="AboutMe-information-Avatar"  />
                </div>
            </div>
        </div>
    );
};
export default AboutMe;
